export const extractError = (obj: any, path: string): any => {
  if (!path) return

  return path
    .replace(/\[(\d+)\]/g, '.$1')
    .split('.')
    .reduce(
      (res, key) => (res !== null && res !== undefined ? res[key] : undefined),
      obj,
    )
}
